<script lang="ts" setup>
import DOMPurify from 'dompurify'

withDefaults(
  defineProps<{
    label?: string
    errors?: string[]
  }>(),
  {
    label: '',
    errors: () => [],
  },
)
</script>

<template>
  <div>
    <div class="tw:flex tw:justify-between">
      <div
        v-if="label"
        class="tw:mb-1 tw:text-sm tw:font-semibold tw:text-gray-700 tw:dark:text-gray-300"
      >
        {{ label }}
      </div>
      <slot name="misc" />
    </div>
    <slot />
    <div
      v-if="$slots.help"
      class="tw:mt-1 tw:text-sm tw:text-gray-600 tw:dark:text-gray-400"
    >
      <slot name="help" />
    </div>

    <ul
      v-if="errors.length > 0"
      class="tw:mt-1 tw:list-none tw:p-0 tw:text-xs tw:font-semibold tw:text-red-500"
      data-test="input-errors"
    >
      <li
        v-for="(error, index) in errors"
        :key="index"
        class="tw:mt-2"
        v-html="DOMPurify.sanitize(error)"
      />
    </ul>
  </div>
</template>
